// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  height: 2.3rem;
  width: 2.3rem;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/components/rglogo/rglogo.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,aAAA;EACA,eAAA;AACJ","sourcesContent":["img {\n    height: 2.3rem;\n    width: 2.3rem;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
